import CustomSweetAlert from 'components/Shared/CustomSweetAlert';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";

const StepSeven = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({
        isConfirm: false
    });
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setFormData(prevState => ({
                ...prevState,
                isConfirm: storedData?.confirmedKeyfob,
            }));
        }
    }, []);

    const validateForm = (formData) => {
        const { isConfirm } = formData;
        const errors = {
            isConfirm: isConfirm === false && 'A confirm is required',
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitKeyfob?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                });
                if (response.status === 200) {
                    handleNext({ confirmedKeyfob: formData });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const handleCheck = (e) => {
        setFormData({
            ...formData,
            isConfirm: !formData?.isConfirm
        })
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2 >7. Keyfob</h2>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5>A key fob will be issued to all employees on commencement of employment.</h5></span>
                <span><h5>As in line with the company rules outlined in section 13 in the Employee Handbook the following rules apply: </h5></span>
                <div>
                    <ul>
                        <li><h5 className='fw-100'>Once key fobs are issued to employees, they become their responsibility.</h5></li>
                        <li><h5 className='fw-100'>In the event of a key fob needing to be replaced, this should be reported to the line manager in order to get the fob cancelled and a replacement issued.</h5></li>
                        <li><h5 className='fw-100'>A charge of £5.00 will be applied for the issue of the replacement, and the necessary deduction made from the employee's wages.</h5></li>
                        <li><h5 className='fw-100'>Repeated instances of key fob replacements may render an employee liable to disciplinary action.</h5></li>

                    </ul>
                </div>
            </Col>

            <Col sm={12} md={12} className=''>
                <Form.Group className='d-flex'>
                    <Form.Check.Label style={{ textAlign: 'left' }}>
                        <Form.Check.Input
                            type="checkbox"
                            checked={formData?.isConfirm === true}
                            onChange={handleCheck}
                        ></Form.Check.Input>
                        <span className="form-check-sign" style={{ paddingRight: "10px" }}></span>
                        <><span>Please confirm you have read, understood, and agree to the above</span><span className="star">*</span>
                        </>
                    </Form.Check.Label>
                </Form.Group>
                {errors.isConfirm && <Form.Text className="text-danger d-flex"> <span className="star">*</span> {errors.isConfirm} </Form.Text>}
            </Col>

            <Col sm={12} className="d-flex justify-content-between mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepSeven;





